// @mui
import { useTheme } from "@mui/material/styles";
import { Box } from "@mui/material";

// ----------------------------------------------------------------------

export default function SentIcon({ ...other }) {
  const theme = useTheme();
  const PRIMARY_MAIN = theme.palette.primary.main;

  return (
    <Box {...other}>
      <svg viewBox="0 0 40 40" width="70" height="70" fill="none">
        <circle cx="20" cy="20" r="20" fill={PRIMARY_MAIN} />
        <mask
          id="mask0"
          maskUnits="userSpaceOnUse"
          x="8"
          y="8"
          width="24"
          height="24"
        >
          <rect x="8" y="8" width="24" height="24" fill="white" />
        </mask>
        <g mask="url(#mask0)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M20 21C18.3431 21 17 19.6569 17 18C17 16.3431 18.3431 15 20 15C21.6569 15 23 16.3431 23 18C23 19.6569 21.6569 21 20 21ZM13 18C13 23.25 20 29 20 29C20 29 27 23.25 27 18C27 14.13 23.87 11 20 11C16.13 11 13 14.13 13 18C13 18 13 23.25 13 18ZM15 18C15 15.2346 17.2346 13 20 13C22.7654 13 25 15.2346 25 18C25 19.8607 23.6843 22.1296 21.9654 24.1861C21.2714 25.0165 20.5732 25.7402 20 26.2974C19.4268 25.7402 18.7286 25.0165 18.0346 24.1861C16.3157 22.1296 15 19.8607 15 18C15 18 15 15.2346 15 18Z"
            fill="white"
          />
        </g>
      </svg>
    </Box>
  );
}
